import {
  JobCountResponse,
  JobCountDetailResponse,
  IndustryLResponse,
} from '@doda/api-client/aspida/@types';
import { DisplayIndustryL } from '../industryCheckReducer';

/**
 * 業種設定モーダルで表示される業種マスタへそれぞれに対応した求人件数を追加したデータを作る関数
 * @param {IndustryLResponse[]} industryList - 業種カテゴリーのリスト
 * @param {JobCountResponse} jobCount - 求人件数のレスポンスデータ
 * @returns {DisplayIndustryL[]} 求人件数を追加した業種カテゴリーのリスト
 */
export const createIndustryDisplayData = (
  industryList: IndustryLResponse[],
  jobCount: JobCountResponse
): DisplayIndustryL[] => {
  return industryList.map((industryL) => ({
    ...industryL,
    jobCount: findJobCount(jobCount.industryLList, industryL.id),
    industrySList: industryL.industrySList.map((industryS) => ({
      ...industryS,
      jobCount: findJobCount(jobCount.industrySList, industryS.id),
    })),
  }));
};

/**
 * 求人件数レスポンスから、特定のidの求人件数を取得する関数
 * @param {JobCountDetailResponse[] | undefined} countList - 求人件数の詳細リスト
 * @param {string} id - 求人件数を取得する業種のID
 * @returns {number} 指定したIDに対応する求人件数
 */
export const findJobCount = (
  countList: JobCountDetailResponse[] | undefined,
  id: string
): number => countList?.find((i) => id === i.id)?.count ?? 0;
